module.exports = "<div class=\"table-section\">\n    <div class=\"table-main-header\" ng-transclude=\"mainHeader\">\n\n    </div>\n    <!-- .table-main-header END -->\n\n    <div ng-transclude=\"header\">\n\n    </div>\n    <!-- .table-header END -->\n\n    <div class=\"table-body\" ng-transclude=\"body\">\n\n    </div>\n    <!-- .table-body END -->\n</div>\n<!-- .table-section END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpPlainTable/adpPlainTable.html
// module id = 651
// module chunks = 0